/* esm.sh - hast-util-to-text@4.0.2 */
export * from "/*hast-util-to-text@4.0.2/esnext/hast-util-to-text.mjs";
